export default __webpack_public_path__ + "static/media/gallery-7.7639d794.jpg";